import React, { Component } from 'react';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Box from '../ui/Box';
import Select from 'react-select';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';


//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

export default class MoveLock extends Component {

  constructor(props) {
    super(props);
    this.state = {
      migration_home: null,
      all_devices: [],
      all_rooms: [],
      all_food: [],
      deviceId: '',
      room_num: '',
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      isDemoLogin: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 10;
  componentDidMount() {
    console.log("I am ahgsdhsadghas");
    this.getAllRooms();
    this.getLockHome();
  }

  getAllRooms() {
    let user = ls.getUserDetails();
    if (user.hotel_id) {
      ds.getAllRooms(user.hotel_id,
        data => {
          if (data && data.length) {
            for (let i of data) {
              i.label = i.hotel_room_id ? i.hotel_room_id.name : '';
              i.value = i.hotel_room_id._id;
              i.show = true;
            }
          }
          this.setState({
            all_rooms: data,
          })
        }, error => {
          console.log(error);
        })
    }
  }
  getLockHome() {
    let user = ls.getUserDetails();
    if (user.hotel_id) {
      ds.getLockHome(user.hotel_id,
        data => {
          if (data && data.migrationHome) {
            this.setState({
              migration_home: data.migrationHome
            })
          }
        }, error => {
          console.log(error);
        })
    }
  }
  checkDevices() {
    let devicesList = this.state.deviceId.split(',');
    let obj = {
      devices: devicesList
    }
    if (this.state.migration_home) {
      obj.home_id = this.state.migration_home.id;
    }
    ds.postDevicesCheck(obj, (data) => {
      if (data && data.length) {
        let errdevices = [];
        let devices = [];
        for (let i of data) {
          if (i.status == 200) {
            devices.push(i);
          } else {
            errdevices.push(i);
          }
        }
        if (devices && devices.length) {
          let adddevices = this.state.all_devices;
          devices = [...devices, ...adddevices];
          this.setState({
            all_devices: devices
          })
        }
        if (errdevices && errdevices.length) {
          this.setState({
            dialog: {
              open: true,
              head: '',
              body: <Box header="Unable to add below devices"><div>{errdevices.map((j) => {
                return (
                  <li>{j.deviceId} - {j.message}</li>
                )
              })}</div>
              </Box>,
              actions: [
                <FlatButton
                  label="Cancel"
                  primary
                  onClick={this.closeDialog.bind(this)}
                />
              ]
            }
          })
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.getAllFood(0);
    }
  }

  editNumber(row, e) {
    let allrooms = this.state.all_rooms;
    this.setState({
      dialog: {
        open: true,
        head: "",
        body: <Box header="Select a Room"><div style={{ minHeight: '250px' }}>
          <Select
            id="room_numid"
            ref={(ref) => { this.select = ref; }}
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            options={allrooms}
            simpleValue
            clearable={true}
            name="room_num"
            disabled={false}
            value={row.room_num}
            onChange={(newValue) => {
              let devices = this.state.all_devices;
              for (let i = 0; i < devices.length; i++) {
                if (devices[i].deviceId === row.deviceId) {
                  this.state.all_rooms.map((j) => {
                    if (j.value == newValue) {
                      devices[i].room_num = j.label
                    }
                  })
                  devices[i].hotelRoomId = newValue;
                }
              }
              this.setState({ all_devices: devices }, () => {
                console.log(this.state.all_devices);
                this.closeDialog();
              });
            }}
            searchable={true}
            placeholder="Room Number"
            style={{ marginBottom: "15px" }}
          />
        </div></Box>,
        actions: [
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  moveLocks() {
    let devices = this.state.all_devices;
    console.log(devices);
    let selectedhome;
    let selectedrooms = [];
    let flag = 0;
    for (let i of devices) {
      if (i.home_id && i.home_id._id) {
        selectedhome = i.home_id._id;
      } else {
        selectedhome = i.home_id;
      }

      if (i.hotelRoomId && i.room_num) {
        selectedrooms.push(i.hotelRoomId);
      } else {
        flag = 1;
      }
    }
    if (flag == 1) {
      this.setState({
        dialog: {
          open: true,
          head: 'Error',
          body: 'Make sure all devices are assigned rooms',
          actions: [
            <FlatButton
              label="Okay"
              primary
              onClick={this.closeDialog.bind(this)}
            />
          ]
        }
      });
    } else {
      if (selectedrooms.length !== new Set(selectedrooms).size) {
        this.setState({
          dialog: {
            open: true,
            head: 'Error',
            body: 'More than one device cannot be assigned same room.',
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
        })
      } else {
        const userData = ls.getUserDetails();
        let obj = {
          hotelId: userData.hotel_id,
          devices: devices
        }
        if (this.state.migration_home) {
          obj.homeId = this.state.migration_home.id;
        } else {
          obj.homeId = selectedhome;
        }
        ds.postMoveLocks(obj, (data) => {
          if (data && data.status == 1) {
            this.setState({
              dialog: {
                open: true,
                head: 'Success',
                body: 'Locks moved succesfully',
                actions: [
                  <FlatButton
                    label="Okay"
                    primary
                    onClick={this.closeDialog.bind(this)}
                  />
                ]
              },
              all_devices: []
            })
          }
        }, (err) => {
          console.log(err);
        })
      }
    }
  }

  deleteNumber(row, e) {
    console.log(row, e);
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete the selected row?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              let all_devices = [];
              for (let i = 0; i < this.state.all_devices.length; i++) {
                if (this.state.all_devices[i].deviceId == row.deviceId) {
                  continue;
                } else {
                  all_devices.push(this.state.all_devices[i]);
                }
              }
              this.setState({ all_devices: all_devices });
              this.closeDialog();
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    })
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
    //onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Move Locks,Gateways To Hotel'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>
          <div>
            {
              this.state.migration_home && <div style={{ "fontSize": "12px" }}>
                Note: Make sure all the devices to be moved are added in HOME - '{this.state.migration_home.display_name}' with ID: '{this.state.migration_home.id}'.</div>
            }
          </div>
          <TextField
            floatingLabelText="Enter Device Id/Id's comma seperated "
            name="deviceId"
            className="w-100"
            value={this.state.deviceId}
            onChange={(e, val) => {
              this.setState({
                deviceId: val
              })
            }}
          />
          <RaisedButton
            label="Add Device"
            primary
            type="submit"
            disabled={this.state.deviceId == ''}
            onClick={() => {
              this.checkDevices();
            }}
          />

          {this.state.all_devices && this.state.all_devices.length > 0 && <div> <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Device Id">Device Id</TableHeaderColumn>

                <TableHeaderColumn tooltip="Room Number" >
                  Room No
                </TableHeaderColumn>
                <TableHeaderColumn tooltip="Delete" >
                  Delete
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_devices.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.deviceId}</TableRowColumn>

                    <TableRowColumn style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                      {row.room_num ? <div onClick={(e) => { this.editNumber(row, e) }} style={{ "color": "#00bcd4", "textDecoration": "underline" }}>{row.room_num}</div> :
                        <div onClick={(e) => { this.editNumber(row, e) }} style={{ "color": "#00bcd4", "textDecoration": "underline" }}>Select</div>}
                    </TableRowColumn>
                    <TableRowColumn style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                      <i className="material-icons warn-fg"
                        style={{ cursor: 'pointer' }}
                        onClick={this.deleteNumber.bind(this, row)}
                      >
                        delete
                      </i>
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>

            <TableFooter></TableFooter>
          </Table>
            <div>
              <RaisedButton
                label="Move Devices to Hotel"
                primary
                type="submit"
                onClick={() => {
                  this.moveLocks()
                }}
              />
            </div>
          </div>
          }
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/movelock/MoveLock.js